export default {
  'error.to_small_image': 'Please select image with resolution {width} x {height} pixels or higher.',
  'error.array_length.not_is': '{key} should contain {value} items',
  'error.array_length.too_short': '{key} should contain at least {value} items',
  'error.array_length.too_long': '{key} shouldn\'t contain more than {value} items',
  'error.not_unique': 'The value is not unique.',
  'error.not_unique_user_email': 'Account with such name already exists.',
  'error.not equality': 'Value has to be different.',
  'error.too_small_image': 'Image has to be bigger than {width}*{height}px',
  'error.bad_credentials': 'Can\'t find user or password',
  'error.streaming.edit_disabled': 'Cannot edit past events.',
  'error.already_published': 'Voting has already published.',
  'error.length': 'Too short.',
  'error.upper_case.required': 'Upper case letters are required.',
  'error.digit.required': 'Digit are required.',
  'error.special_symbol.required': 'Special symbols are required.',
  'error.duplicate': 'This voting intersect with another voting. Please check voting\'s time.'
}



// WEBPACK FOOTER //
// ./src/config/messages/en.js